// Informations légales centralisées, utilisées par les pages mentions légales, CGU, CGV,
// confidentialité et cookies. Source : annuaire des entreprises (recherche-entreprises.api.gouv.fr).

export const legalCompany = {
  name: 'DEBOOSERE CHAUFFAGE SANITAIRE',
  tradeName: 'D.C.S',
  legalForm: 'Société à responsabilité limitée (SARL)',
  address: '445 boulevard Gambetta, 59200 Tourcoing, France',
  siren: '844 524 835',
  siret: '844 524 835 00015',
  rcs: 'RCS Lille Métropole 844 524 835',
  vat: 'FR89 844 524 835',
  naf: '43.22A — Travaux d’installation d’eau et de gaz en tous locaux',
  phone: '07 89 46 43 09',
  phoneHref: 'tel:+33789464309',
  director: 'Thibaut Deboosère, gérant',
  rge: 'Entreprise titulaire d’une qualification RGE (Reconnu Garant de l’Environnement).',
} as const

export const legalHost = {
  name: 'Netlify, Inc.',
  address: '101 2nd Street, Suite 575, San Francisco, CA 94105, États-Unis',
  website: 'https://www.netlify.com',
} as const

export const legalUpdatedAt = '27 septembre 2026'

export const legalLinks = [
  { label: 'Mentions légales', to: '/mentions-legales' },
  { label: 'CGU', to: '/cgu' },
  { label: 'CGV', to: '/cgv' },
  { label: 'Confidentialité', to: '/politique-de-confidentialite' },
  { label: 'Cookies', to: '/cookies' },
] as const
